import React, { useEffect, useState, useRef } from 'react';
import './solutions/Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "",
    poster: "/images/birds.jpg",
    heading: "A Strong Network of Trusted Partnerships",
    subheading: "Where modern networks converge and tomorrow’s service delivery begins.",
    buttonLink: "https://www.youtube.com/watch?v=tbUjpfa86FY"
  }
];

const brandGuide = [
  {
  name: 'Brand Guide',
  link: 'https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/other%2FGo!Foton%20Brand%20Guidelines.pdf?alt=media&token=562a164f-2110-441a-b6d1-9ff53371cc30'
},
{
  name: 'Company Description',
  link: '/decoding-the-gofoton-brand/'
},
{
  name: 'Logo',
  link: 'https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FGoFoton%20Logo.png?alt=media&token=752e6ff9-fc99-41bc-8074-2eaa74451894'
},
{
  name: 'Media Contact',
  link: 'mailto:brand@gofoton.com'
},

]

const qaData2 = [
  {
    question: "What types of partners does Go!Foton work with?",
    answer:
      "Go!Foton works with distributors, OEMs, private-label partners, resellers, and system integrators."
  },
  {
    question: "Why partner with Go!Foton?",
    answer:
      "We have received a wide range of feedback from customers and partners about why they choose Go!Foton. This includes our product quality, technical expertise, willingness and ability to customize solutions, excellent support, reliability, market focus, and innovation."
  },
  {
    question: "What regions or markets do you support through partners?",
    answer:
      "Our partners span the globe and focus on AI data centers, Telco/MSO, and enterprise fiber networks."
  },
  {
    question: "Can resellers access marketing or sales enablement materials?",
    answer:
      "Absolutely! In addition to the brand resources available here, our marketing team is available to help with collateral and sales materials. They may be reached at brand@gofoton.com."
  },
  {
    question: "What sales support does Go!Foton provide to partners?",
    answer:
      "Go!Foton provides our partners with access to a dedicated sales liaison and expert."
  },
  {
    question: "Can partners request samples or evaluation units?",
    answer:
      "Yes! Samples and trial units are available upon request through your account manager."
  },
  {
    question: "Do partners have access to engineering or product experts?",
    answer:
      "Yes. In addition to account managers, technical experts and customer care representatives are available for support."
  },
  {
    question: "Where are Go!Foton products manufactured and/or assembled?",
    answer:
      "Go!Foton manufactures products in the United States and the Philippines."
  },
  {
    question: "Who should I contact with partner-related questions?",
    answer:
      'If you are interested in becoming a partner, email Sales@gofoton.com with the subject line "Partnership Inquiry."'
  }
];


function Partners() {

  const [showPopup, setShowPopup] = useState(false);
  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = index => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  window.addEventListener("resize", handleResize);
  console.log('isMobile?', isMobile)
  return () => window.removeEventListener("resize", handleResize);
}, []);

const productFamilies = [
  'Fiber Cable Assemblies',
  'Passive Optical Components',
  'Cassettes',
  'Fiber Panels',
  'Frames',
];


  return (
    <div className="contact-page">
      <div className="curved-header-partners" style={{ backgroundPosition: isMobile ? 'center' : ''}}> 
        <center><h1 style={{ fontSize: isMobile ? '40px' : ''}}>A Strong Network of Partnerships</h1></center>
      </div>


      <svg  className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
        <path
          d="
            M0,150
            H1440
            V0
            Q720,75 0,0
            Z
          "
          fill="white"
        />
      </svg>

      <div className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Distribution partners</h2>
          <p className="solution-section-centeredText-description">Whether you’re looking for a one-stop shop, single evaluation unit, or if you’re ready to purchase, our global distribution partners are ready to deliver. Go!Foton products may be purchased from our distributor partners.​ ​</p>
       <div className="partner-logos-wrapper">
          <a href="https://www.kgpco.com/" target="_blank" rel="noopener noreferrer">
            <img src="/images/partnerLogos/kgpco.png" alt="KGPCo" />
          </a>
          <a href="https://www.anixter.com/">
            <img src="/images/partnerLogos/wesco.webp" target="_blank" alt="Anixter/Wesco" />
          </a>
          <a href="https://www.graybar.com/">
            <img src="/images/partnerLogos/graybar.png" target="_blank" alt="Graybar" />
          </a>
          {/* <a href="https://www.netceed.com/" target="_blank">
            <img src="/images/partnerLogos/netceed.svg" alt="Netceed" />
          </a> */}
          <a href="https://kmmcorp.net/" target="_blank">
            <img src="/images/partnerLogos/kmm.svg" alt="KMM Logistics & Network Services" />
          </a>
        </div>
        </div>
      </div>

          <div className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Partner Resources</h2>
          <p className="solution-section-centeredText-description">Check out our resources for media, analyst, and partners. Can’t find what you’re looking for?​</p>
       
<div className="brand-grid-wrapper partner-resources-grid" style={{ marginTop: 30 }}>
{brandGuide.map((item, i) => (
  <div className="brand-grid-card" key={i}>
    <p style={{ paddingBottom: 20}}>{item.name}</p>
    {item.name === 'Company Description' ? (
      <a className="cta-button" onClick={() => setShowPopup(true)}>
        CLICK HERE
      </a>
    ) : 
    <a href={item.link} style={{textDecoration: 'none'}} className="cta-button" target="_blank" rel="noopener noreferrer">
      Click Here
    </a>}
  </div>
))}

    </div>

{showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <p>
              Based in the USA with teams around the world, Go!Foton is at the forefront of advanced
              optical and photonics innovation. We engineer solutions to enhance user experience by
              offering customers unique approaches to solve real-world problems in connectivity,
              imaging, and beyond.
              <br /><br />
              Go!Foton technology stands apart with feature-rich and performance-optimized solutions.
              We keep our customers satisfied and businesses performing, ensuring new and improved
              experiences for all.
              <br /><br />
              Inspired by nature and physics, the sky is the limit when imagining what’s possible and
              creating what’s next.
              <br /><br />
              Discover new dimensions at gofoton.com.
            </p>
          </div>
        </div>
      )}

              {/* <a href="mailto:brand@gofoton.com" style={{ textDecoration: 'none'}}  className='cta-button'>Reach Out</a> */}

        </div>
        </div>



          <div className="solutions-section-centeredText">
      <div className="solutions-section-centeredText-text-container">
        <h2 className="solutions-section-centeredText-subheading" style={{textAlign: 'center'}}>Frequently Asked Questions</h2>
      </div>

      <div className="qa-accordion">
      {qaData2.map((item, index) => (
        <div key={index} className="accordion-item">
          <div
            className="accordion-question"
            onClick={() => toggleIndex(index)}
          >
            <span style={{fontSize: 20}}>{item.question}</span>
            <span className="icon">{activeIndex === index ? '−' : '+'}</span>
          </div>
          {activeIndex === index && (
            <div className="accordion-answer">
              <p style={{fontSize: 20, textAlign: 'left'}}>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
    </div>



        <div className="curved-footer-solutions">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>

    </div>

    
  );
}

export default Partners;
